import React from 'react';
import { useQuery } from 'react-query';
import loadCms, {
  getZone,
  placeHolderApiZone,
  selectAllowedComponents,
  selectStandardBannerComponents,
} from '../../api/CmsApi';
import { ApiContentPage, ApiZone } from '../../api/generated-client/Content-Service-A.v1';
import '@chewy/kib-content-groups-styles/dist/styles/kib-section-heading.css';
import { AnimalTypeId, PetInterface } from '../../types/pet';
import {
  CMS_BIRD_SELECTION_KEY,
  CMS_CAT_SELECTION_KEY,
  CMS_DOG_SELECTION_KEY,
  CMS_FARM_ANIMAL_SELECTION_KEY,
  CMS_FISH_SELECTION_KEY,
  CMS_HORSE_SELECTION_KEY,
  CMS_PET_GENERAL_TYPE,
  CMS_REPTILE_SELECTION_KEY,
  CMS_SMALL_PET_SELECTION_KEY,
  PET_PAGE_ZONE,
} from '../../api/CmsApiConstants';
import { retryCount } from '../../util/reactQueryOptions';
import ResizeBanner from './ResizeBanner';
import './pet-view-content.scss';

export const checkSpecialtyPet = (petTypeId: number) =>
  ![AnimalTypeId.dog, AnimalTypeId.cat].includes(petTypeId);

export const PetViewContent = ({ petProfile }: { petProfile: PetInterface }) => {
  const cmsCacheKey = loadCms.key;

  let selectionKey: string;

  switch (petProfile.petType.id) {
    case AnimalTypeId.dog:
      selectionKey = CMS_DOG_SELECTION_KEY;
      break;
    case AnimalTypeId.cat:
      selectionKey = CMS_CAT_SELECTION_KEY;
      break;
    case AnimalTypeId.fish:
      selectionKey = CMS_FISH_SELECTION_KEY;
      break;
    case AnimalTypeId.bird:
      selectionKey = CMS_BIRD_SELECTION_KEY;
      break;
    case AnimalTypeId.smallPet:
      selectionKey = CMS_SMALL_PET_SELECTION_KEY;
      break;
    case AnimalTypeId.reptile:
      selectionKey = CMS_REPTILE_SELECTION_KEY;
      break;
    case AnimalTypeId.horse:
      selectionKey = CMS_HORSE_SELECTION_KEY;
      break;
    case AnimalTypeId.farmAnimal:
      selectionKey = CMS_FARM_ANIMAL_SELECTION_KEY;
      break;
    default:
      // Default case if pet type doesn't match any of the above cases
      selectionKey = '';
  }

  const getRelevantCmsContent = (data: ApiContentPage): ApiZone => {
    // request from the first zone
    const selectedZone = getZone(PET_PAGE_ZONE - 1, data);
    // filter what's in the first zone by the standard banner components
    const filteredZoneData = selectStandardBannerComponents(selectedZone!);
    return filteredZoneData;
  };

  const { isLoadingError: cmsBannerLoadingError, data: cmsData } = useQuery(
    [cmsCacheKey, null, CMS_PET_GENERAL_TYPE, selectionKey],
    loadCms,
    {
      select: getRelevantCmsContent,
      retry: retryCount,
    },
  );

  let cmsPetData = cmsData ? selectAllowedComponents(cmsData) : placeHolderApiZone;

  return (
    cmsPetData &&
    cmsPetData.components.length > 0 && (
      <div className="pet-profile__cms-banner">
        <ResizeBanner data={cmsPetData.components[0]} />
      </div>
    )
  );
};
